export const vertAddToBagRecSlick = (listElements, recList) => {

  //For Add to Bag
  $('.atbUp, .atbDown').on('click', function() {
    if ($(':animated').length) {
        //stops user from rapidly clicking arrows
        return false;
    }
    var scrollUp = $(this).hasClass('atb-arrow-up'),
      scrollDown = $(this).hasClass('atb-arrow-down'),
      $altImageUL = $('#add-to-bag-list-contain ul'),
      topPos = ($altImageUL).position().top,
      containerHeight = parseInt($('#add-to-bag-rec').height(), 10),
      itemsHeight = parseInt($altImageUL.height(), 10),
      stopVertScroll = (itemsHeight + topPos) > (containerHeight),
      scrollSpeed = 500;

    if (scrollDown && stopVertScroll) {
      $('.atb-arrow-up').removeClass('disabled-arrow');
      $($altImageUL).animate({
        'top': "-=171"
      }, scrollSpeed);
      if ((itemsHeight + (topPos) - 25) < (containerHeight)) $('.atb-arrow-down').addClass('disabled-arrow');
    }
    if (scrollUp && topPos < 0) {
      $('.atb-arrow-down').removeClass('disabled-arrow');
      $($altImageUL).animate({
        'top': "+=171"
      }, scrollSpeed);
      if ((topPos * -1) < 175) $('.atb-arrow-up').addClass('disabled-arrow');
    }
  });

  //For Add to Registry
  $('.atrUp, .atrDown').on('click', function() {
    if ($(':animated').length) {
        //stops user from rapidly clicking arrows
        return false;
    }
    var scrollUp = $(this).hasClass('atb-arrow-up'),
      scrollDown = $(this).hasClass('atb-arrow-down'),
      $altImageUL = $('#add-to-registry-list-contain ul'),
      topPos = ($altImageUL).position().top,
      containerHeight = parseInt($('#add-to-registry-rec').height(), 10),
      itemsHeight = parseInt($altImageUL.height(), 10),
      stopVertScroll = (itemsHeight + topPos) > (containerHeight),
      scrollSpeed = 500;

    if (scrollDown && stopVertScroll) {
      $('.atb-arrow-up').removeClass('disabled-arrow');
      $($altImageUL).animate({
        'top': "-=171"
      }, scrollSpeed);
      if ((itemsHeight + (topPos) - 25) < (containerHeight)) $('.atb-arrow-down').addClass('disabled-arrow');
    }
    if (scrollUp && topPos < 0) {
      $('.atb-arrow-down').removeClass('disabled-arrow');
      $($altImageUL).animate({
        'top': "+=171"
      }, scrollSpeed);
      if ((topPos * -1) < 175) $('.atb-arrow-up').addClass('disabled-arrow');
    }
  });

}
